import React from "react";

const TermsOfUse = () => {
  return (
    <>
      <div>
        <div className="section section-padding-bottom mt-5">
          <div className="container">
            <div className="row max-mb-n50">
              <div className="col-lg-12 col-12 order-lg-2 max-mb-50">
                {/* Terms of Use Wrapper Start */}
                <div className="terms-of-use-wrapper">
                  <div className="content">
                    <p>
                      Bu Qaydalar və Şərtlər (“Qaydalar”) Azərbaycan
                      Respublikasının Mülki Məcəlləsi, “Elektron ticarət
                      haqqında”, “Elektron imza və elektron sənəd haqqında”,
                      “Telekommunikasiya haqqında”, “İnformasiya,
                      informasiyalaşdırma və informasiyanın mühafizəsi
                      haqqında”, “Fərdi məlumatlar haqqında” Azərbaycan
                      Respublikası qanunlarına və bu qanunlara müvafiq olaraq
                      qəbul edilmiş digər normativ aktlara müvafiq olaraq
                      hazırlanmışdır və sayt vasitəsilə bağlanan müqavilələrin
                      hüquqi tənzimlənməsini nəzərdə tutur.
                    </p>
                    <p>
                      Bu Qaydalar fiziki və hüquqi şəxslərlə
                      <a
                        href="https://turanozbahceci.com"
                        target="_blank"
                        style={{
                          color: "#20AD96",
                          textDecoration: "underline",
                        }}
                        className="mx-2"
                      >
                        www.https://turanozbahceci.com
                      </a>{" "}
                      saytı (“Sayt”) üzərindən əldə edilən (alınan) xidmətlərin
                      şərtlərini müəyyən edir. Sayt üzərindən hər hansı xidməti
                      sifariş etməzdən əvvəl bu qaydaları{" "}
                      <strong>TAM OLARAQ</strong> oxumaq lazımdır !
                    </p>
                    <p>
                      Burada qeyd olunan şərtlərdən hər hansı birini qəbul
                      etmirsinizsə sifariş əməliyyatlarınızı ödəniş etmədən ləğv
                      etməyiniz vacibdir. Bu Qaydaların məqsədləri üçün www.
                      <a
                        href="https://turanozbahceci.com"
                        target="_blank"
                        style={{
                          color: "#20AD96",
                          textDecoration: "underline",
                        }}
                        className="mx-2"
                      >
                        www.https://turanozbahceci.com
                      </a>
                      saytı “Sayt” olaraq, saytda qeydiyyatdan keçərək xidmət
                      alan İstifadəçilər <strong>“Alıcı”</strong>, saytda
                      təkliflərini yerləşdirərək öz xidmətlərini təklif edən
                      şəxs(lər) isə <strong>“Satıcı”</strong>, birlikdə{" "}
                      <strong>“Tərəflər”</strong> olaraq qeyd olunacaqdır.
                    </p>
                    <ol>
                      <strong>
                        <li>Ümumi müddəalar</li>
                      </strong>
                      <p>
                        1.1. Saytda qeydiyyatdan keçən hər bir Alıcı özünün adı,
                        soyadı və ata adı ilə qeydiyyatdan keçməlidir. Saxta,
                        uydurma və qeyri real adlarla qeydiyyatdan keçən
                        şəxslər, gələcəkdə bununla bağlı yaranacaq riskləri
                        daşıyacaqlar. Qeydiyyatdan keçən hər bir şəxs qeyd
                        olunan müqavilə və istifadə şərtlərini oxumuş və qəbul
                        etmiş sayılır. Müqavilə şərtləri Saytdan ödəniş edilərək
                        əldə edilən aşağıdakı xidmətlər üçün keçərlidir:
                        <br />- Kouç Sessiyaları; <br /> - Karyera Mərkəzi
                        Xidmətləri;
                        <br /> - İnsan Resursları Portalı.
                      </p>
                      <p>
                        1.2. Saytda göstərilən istənilən xidmətlərdən yaralanmaq
                        üçün Alıcı mütləq qaydada saytda qeydiyyatdan
                        keçməlidir. Alıcının qeydiyyatdan keçərkən təqdim etdiyi
                        məlumatlarının hər hansı birində (ad, soyad, ata adı,
                        e-mail ünvan, mobil və ya stasionar telefon nömrəsi və
                        s.) qeyd olunan məlumatların doğru olmaması onun
                        məsuliyyət dairəsindədir. Saytda qeydiyyatdan keçərək
                        xidmət alan Alıcı bu məlumatların doğruluğunu qəbul
                        etmiş sayılır. Alıcının qeyd etdiyi e-mail ünvandan
                        gələcəkdə hər hansı bir bildiriş göndərmək üçün istifadə
                        edilə bilər. Bu e-mail ünvanın etibarlı olması Alıcının
                        məsuliyyət dairəsinə daxildir. Alıcının e-mail
                        ünvanındakı hər hansı bir xətadan dolayı məlumatların
                        çatmaması və ya vaxtında çatmaması Satıcının
                        məsuliyyətinə aid deyil. Alıcının qeydiyyat zamanı
                        təqdim etdiyi məlumatların doğru olmaması halında,
                        Satıcı xidmətin göstərilməsindən imtina etmək və ya
                        Alıcının qeydiyyatını ləğv etmək hüququna malikdir.
                      </p>
                      <p>
                        1.3. Alıcı istifadəçi adı və şifrənin təhlükəsizliyini
                        təmin etməli, onun başqa şəxslər tərəfindən istifadə
                        olunmamasına təminat verməlidir. Əks təqdirdə baş verə
                        biləcək əməliyyatlara görə Sayt heç bir məsuliyyət
                        daşımayacaqdır. Alıcıya göndərilən login barədə
                        məlumatlar Vasitəçidə saxlanılmır. Əgər Alıcı login və
                        ya parolu unudarsa sayt üzərindən müvafiq e-mail
                        ünvanına həmin məlumatların təkrar göndərilməsini tələb
                        edə bilər. Məlumatların yoxlanması məqsədilə Vasitəçi
                        Alıcıdan şəxsiyyət vəsiqəsinin skan olunmuş versiyasını
                        tələb edə bilər.
                      </p>
                      <p>
                        1.4. Sayt Alıcıların hərəkətlərinə görə üçüncü şəxslər
                        qarşısında heç bir məsuliyyət daşımır.
                      </p>
                      <p>
                        1.5. Alıcının Satıcı ilə müqavilə bağlaması üçün ən azı
                        18 yaşı tamam olmalıdır. 18 yaşından azı olan Alıcılar,
                        Sayt vasitəsi ilə Satıcıdan xidmət tələb etməsi üçün
                        onların valideynləri və ya qanuni nümayəndələri
                        tərəfindən təmsil olunmalıdır. Sayt 18 yaşından az olan
                        Alıcı ilə həmin Alıcının valideynləri və ya qanuni
                        nümayəndələri arasında anlaşılmazlıqlardan meydana çıxan
                        hallara/hadisələrə/anlaşılmazlıqlara/mübahisələrə görə
                        heç bir cavabdehlik daşımır.
                      </p>
                      <p>
                        1.6. Alıcının və Satıcının şəxsi məlumatlarının
                        toplanması, saxlanması və istifadəsi ilə bağlı ətraflı
                        məlumat üçün Məxfilik Siyasətimizə baxın.
                      </p>
                      <strong>
                        <li>2. Müqavilə şərtləri və bağlanma qaydaları</li>
                      </strong>
                      <p>
                        2.1. Alıcı saytda yerləşdirilmiş aşağıdakı xidmətlərin
                        əldə edilməsi üçün müqavilə bağlayır:
                      </p>
                      <p>
                        - Kouç Sessiyaları; <br /> - Karyera Mərkəzi Xidmətləri;{" "}
                        <br /> - İnsan Resursları Portalı.
                      </p>
                      <p>
                        2.2. Bu xidmətlərin qiymətləri xidmət paketindən asılı
                        olaraq aşağıdakı kimi müəyyən edilir:
                      </p>
                      <p>
                        - Basic; <br /> - Standart; <br /> - Premium.
                      </p>
                      <p>
                        2.3. Hər bir xidmət paketinin qiyməti aşağıdakı kimi
                        müəyyən edilir (ödəniş günün azərbaycan manatına olan
                        məzənnəsinə müvafiq):
                      </p>
                      <p>
                        - Kouç sessiyalara görə: <br /> Basic - $1.99/aylıq,
                        $9.99/illik <br /> ⁠Standart - $4.99/aylıq, $49.99/illik{" "}
                        <br />
                        Premium - $9.99/aylıq, $99.99/illik
                      </p>
                      <p>
                        ⁠- İş və İşçi axtaran xidmətə görə: <br /> Basic -
                        $1.99/ aylıq, $9.99/illik <br /> ⁠Standart - $4.99/
                        aylıq, $49.99/illik <br /> Premium - $9.99/aylıq,
                        $99.99/illik
                      </p>
                      <p>
                        2.4. Müqavilə şərtləri barədə razılığa gəldikdən sonra
                        Alıcı ödəniş etməlidir.
                      </p>
                      <p>
                        2.4. Ödəniş Alıcı tərəfindən bank kartı ilə olacaq.
                        Müvafiq paketi seçdikdən sonra tarifə uyğun məbləğin
                        ödənişi üçün bankın ödəniş səhifəsinə yönləndiriləcək.
                      </p>
                      <p>
                        2.5. Ödəniş tam icra edildikdən sonra Satıcı Alıcıya
                        bütün rekvizitlərini və əlaqə vasitələrini (e-mail,
                        telefon nömrəsi) göndərir və Tərəflərin müqavilənin
                        icrasına başlayırlar. Ödənişdən sonra müqavilənin ləğv
                        edilməsi və ödənişin geri qaytarılması qeyri mümkündür.
                      </p>
                      <p>
                        2.6. Müqavilənin icrası məqsədilə Alıcı təqvim ayı
                        ərzində azı 2 (iki) dəfə təlimçi ilə onlayn qaydada
                        görüş (təlim) əldə edə bilər, eyni zamanda saytda
                        yaradılmış “Sual-Cavab” bölümündə aldığı xidmətə müvafiq
                        olaraq məhdudiyyətsiz sual vermək və cavab almaq hüququ
                        yaranacaq.
                      </p>
                      <strong>
                        <li>
                          3. İstifadəçilərin şəxsi (fərdi) məlumatlarının
                          toplanmasına və istifadəsinə razılığı (Məxfilik
                          şərtləri)
                        </li>
                      </strong>
                      <p>
                        3.1. Saytda qeydiyyatdan keçən Alıcı qeydiyyatdan
                        keçərkən öz razılığı ilə daxil etdiyi şəxsi (fərdi)
                        məlumatlarının Sayt tərəfindən yalnız bu Qaydaların
                        məqsədləri üçün toplanmasına və istifadəsinə razılığını
                        bildirmiş olur.
                      </p>
                      <p>
                        3.2. Sayt Alıcı tərəfindən ona təqdim edilən və özündə
                        toplanmış şəxsi (fərdi) məlumatların təhlükəsizliyinə
                        zəmanət verir və həmin məlumatların qanunsuz olaraq
                        üçüncü şəxslər tərəfindən əldə edilməməsi və istifadə
                        olunmaması üçün hər cür texniki imkana malik olmasını
                        bəyan edir və zəmanət verir.
                      </p>
                      <p>
                        3.3. Saytda toplanan və Alıcıya məxsus olan şəxsi
                        (fərdi) məlumatlar yalnız qanunvericilikdə göstərilən
                        hallarda və qaydada səlahiyyətli dövlət orqanlarına və
                        məhkəməyə təqdim edilə bilər.
                      </p>
                      <p>
                        3.4. Sayt Alıcının şəxsi məlumatını Azərbaycan
                        Respublikasının fərdi məlumatların qorunmasını təmin
                        edən qanunvericiliyə uyğun olaraq qəbul etməli,
                        saxlamalı, istifadə etməli və onun hüquqlarını
                        pozmamalıdır.
                      </p>
                      <p>
                        3.5. Saytın səmərəli istifadəsini və Alıcı və
                        Satıcıların müqavilə şərtərinə əməl edilməsinin təmin
                        edilməsi məqsədilə Alıcının şəxsi məlumatlarının
                        nüsxələnməsi (“back up”) həyata keçirilə bilər.
                      </p>
                      <strong>
                        <li>4.Təhlükəsizlik Şərtləri</li>
                      </strong>
                      <p>
                        Alıcı özünün login və parolunu hər zaman tam məxfi
                        saxlamalıdır. Alıcı heç kəsə öz login və parolunu
                        açıqlamamalıdır. Əgər Alıcı öz login və parolunu kiməsə
                        məlum olmasından şübhələnərsə və ya bu barədə xəbər
                        tutarsa, Alıcı dərhal Saytın əlaqəli şəxsinə barədə
                        məlumat verməlidir və dərhal login və parolunu müvafiq
                        qaydada dəyişməlidir. Alıcınin bu bənd üzrə öhdəlikləri
                        aşağıda göstərilən istisnalardan asılıdır:
                      </p>
                      <p>
                        - Alıcının login və parolunu özünəməxsus və digər
                        şəxslər tərəfindən asanlıqla tapıla bilməyən və ya əldə
                        oluna bilməyən olmalıdır, o cümlədən: doğum tarixindən
                        və ya Alıcının öz və ya ailə üzvünün adından, Alıcının
                        telefon nömrəsindən və ya “1234” kimi ardıcıl
                        rəqəmlərdən istifadə olunmamalıdır.
                      </p>
                      <p>
                        - Xidmətlər üçün Alıcıya məxsus məlumatların
                        təhlükəsizliyi Alıcının normal təhlükəsiz iş qaydalarına
                        riayət olunmasından asılıdır. Alıcı razılaşır ki,
                        xidmətlər vasitəsilə əməliyyatlar həyata keçirərkən,
                        Alıcı əməliyyat həyata keçirmək məqsədilə xidmətlər
                        vasitəsilə ötürülən məlumatlar daxil olmamaq şərtilə,
                        hər hansı məxfi məlumatın kimsəyə açıqlanmamasının təmin
                        olunması üçün bütün lazımı tədbirlər görür.
                      </p>

                      <strong>
                        <li>5.Əqli Mülkiyyət Münasibətləri</li>
                      </strong>
                      <p>
                        Saytda dərc edilən və ya yerləşdirilən və milli və
                        beynəlxalq hüquqi aktlarla əqli mülkiyyət obyekti hesab
                        olunan obyekt və məlumatlar müvafiq qaydada qorunur və
                        qanunsuz yayılmasına və istifadəsinə icazə verilmir.
                        Sayta alıcı və ya satıcı tərəfindən yerləşdirilən və
                        əqli mülkiyyət obyektinə aid ola bilən obyektlərlə bağlı
                        münasibətlər Azərbaycan Respublikasının əqli mülkiyyətə
                        dair (müəlliflik hüququ, əlaqəli hüquqlar, patent, əmtəə
                        nişanı, coğrafi göstərici, ixtira, kəsf, sənaye nümunəsi
                        və s.) qanunvericiliyinə müvafiq olaraq tənzimlənir.
                      </p>
                      <strong>
                        <li>6.Fors-Major Halları</li>
                      </strong>
                      <p>
                        Sayt, xidmətlərin yerinə yetirilməməsinə və ya
                        gecikməsinə görə məsuliyyət daşımır, əgər bu hallar
                        təbii fəlakətlər (yanğın, daşqın, zəlzələ, fırtına,
                        qasırğa və ya digər təbii fəlakətlər), müharibə, işğal,
                        xarici düşmənlərin əməlləri, hərbi əməliyyatlar
                        (müharibə elan olunub-olunmamasından asılı olmayaraq),
                        vətəndaş müharibəsi, üsyan, inqilab, qiyam, hakimiyyətin
                        qəsb edilməsi, müsadirə, terror aktları, milliləşdirmə,
                        dövlət sanksiyaları, qadağalar, embarqolar, əmək
                        mübahisələri, tətil, lokaut, eləcə də elektrik
                        enerjisinin, internet bağlantısının, telekommunikasiya
                        xidmətlərinin və ya xidmətlərin göstərilməsi üçün zəruri
                        olan digər xidmətlərin kəsilməsi və ya sıradan çıxması
                        nəticəsində baş vermişdirsə.
                      </p>
                      <strong>
                        <li>7. Sayta girişə qoyula bilən məhdudiyyətlər</li>
                      </strong>
                      <p>
                        7.1. Sayt, aşağıdakı hallarda istənilən vaxt əvvəlcədən
                        xəbərdarlıq etmədən sayta girişi müvəqqəti və ya qalıcı
                        olaraq dayandıra bilər:
                      </p>
                      <p>
                        -Alıcı tərəfindən müqavilə şərtlərinin pozulması; <br />
                        -Saytın təhlükəsizliyinin təmin edilməsi üçün zəruri
                        hallar; <br /> -Qanunvericiliyin tələblərinin yerinə
                        yetirilməsi. <br /> Sayt belə müvəqqəti dayandırma və ya
                        ləğv etmə nəticəsində baş verə biləcək istənilən itki və
                        ya narahatlığa görə heç bir məsuliyyət daşımır.
                      </p>
                      <p>
                        7.2. Saytda qeydiyyatdan keçmiş Alıcı və ya Satıcı
                        bağladıqları (bağlayacaqları) müqavilə üzrə ödənişin
                        sayt üzərindən deyil, saytdan kənar qaydada (nağd
                        formada, başqa ödəniş sistemləri üzərindən, pdəniş
                        terminalları vasitəsilə, birbaşa kartlararası ödəmə
                        formasında və s.) edilməsini razılaşdırarlarsa və ya bu
                        barədə bir tərəf digər tərəfə təklif irəli sürərsə, o
                        zaman belə razılaşmanı edən Tərəflərin və ya belə təklif
                        irəli sürən Tərəfin sayta girişi birtərəfli qaydada
                        məhdudlaşdırıla və ya ləğv edilə bilər.
                      </p>
                      <strong>
                        <li>8. Müqavilənin müddəti.</li>
                      </strong>
                      <p>
                        Alıcı saytda qeydiyyatdan keçməklə və müvafiq xidmət
                        paketini seçməklə müqavilə müddətini müəyyən edə bilər.
                        Xidmət paketlərinə müvafiq olaraq müqavilə müddəti 1
                        (bir) aylıq və ya 1 (bir) illik müddətə müəyyən edilə
                        bilər.
                      </p>
                      <strong>
                        <li>
                          9.Tətbiq olunan qanunvericilik və mübahisələrin həlli
                        </li>
                      </strong>
                      <p>
                        Bu İstifadə Şərtlərində xüsusi olaraq qeyd olunmayan
                        bütün məsələlər yalnız Azərbaycan Respublikasının
                        qanunvericiliyinə uyğun şəkildə tənzimlənir.
                        Xidmətlərdən istifadə etmə, bu məqsədlə müqavilə
                        bağlamaq və ya bu İstifadə Şərtləri ilə bağlı hər hansı
                        mübahisələr yarandıqda, tərəflər belə mübahisələri
                        danışıqlar yolu ilə həll olunması üçün əlindən gələni
                        etməlidir. Danışıqlar başlayan andan etibarən tərəflər
                        mübahisələri 30 (otuz) gün ərzində həll etməzsə,
                        istənilən tərəf belə mübahisələrlə bağlı Azərbaycan
                        Respublikasının səlahiyyətli və aidiyyatı məhkəmələrinə
                        müraciət edə bilər.
                      </p>
                      <strong>
                        <li>10. Yekun müddəalar</li>
                      </strong>
                      <p>
                        Satıcının xidmətlərindən istifadə edilməsi üçün Sayt
                        tərəfindən aşağıdakı əlaqə vasitəsiləri təmin edilir:{" "}
                        <br /> - Mobil əlaqə nömrəsi:{" "}
                        <a
                          href="tel:+994559004175"
                          style={{
                            color: "#20AD96",
                            textDecoration: "underline",
                          }}
                          className="mx-2"
                        >
                          +994559004175
                        </a>{" "}
                        <br /> - elektron poçt:
                        <a
                          href="mailto:t.ozbahceci@ozbahceci.org"
                          style={{
                            color: "#20AD96",
                            textDecoration: "underline",
                          }}
                          className="mx-2"
                        >
                          www.https://turanozbahceci.com
                        </a>
                      </p>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
